
import { ISanPhamEditRequest } from "../../model/request/san-pham/ISanPhamEditRequest"
import { ISanPhamImportRequest } from "../../model/request/san-pham/ISanPhamImportRequest"
import { apiClient, formatQueryString } from "../apiClient"

export const SAN_PHAM_API_RESOURCE = "san-pham"
export const sanPhamApi = {
    SelectAll: (params?: { dm_coso_id?: number }) => {
        const query = params ? formatQueryString(params) : "";
        return apiClient.get(`${SAN_PHAM_API_RESOURCE}${query ? `?${query}` : ""}`);
    },
    // Insert: (payload: ISanPham) => apiClient.post(`${SAN_PHAM_API_RESOURCE}`, payload),
    // Update: (payload: ISanPham) => apiClient.put(`${SAN_PHAM_API_RESOURCE}`, payload),
    Delete: (id: number) => apiClient.delete(`${SAN_PHAM_API_RESOURCE}/${id}`),
    SaveChange: (payload: ISanPhamEditRequest) => apiClient.post(`${SAN_PHAM_API_RESOURCE}`, payload),
    UpdateThumbMain: (id: number, thumbMain: string) =>
        apiClient.put(`${SAN_PHAM_API_RESOURCE}/update-thumb-main/${id}`, { thumb_main: thumbMain }),
    LoadFromExcel(request: FormData) {
        return apiClient.upload(`${SAN_PHAM_API_RESOURCE}/import/load-from-excel`, request)
    },
    SaveDataExcel(request: ISanPhamImportRequest) {
        return apiClient.post(`${SAN_PHAM_API_RESOURCE}/import/save-data-excel`, request)
    },
    // Các phương thức mới cho import kết hợp
    LoadFromExcelCombined(request: FormData) {
        return apiClient.upload(`${SAN_PHAM_API_RESOURCE}/import/load-from-excel-combined`, request)
    },
    SaveDataExcelCombined(request: ISanPhamImportRequest) {
        return apiClient.post(`${SAN_PHAM_API_RESOURCE}/import/save-data-excel-combined`, request)
    },
    DownloadTemplate() {
        return apiClient.getBlob(`${SAN_PHAM_API_RESOURCE}/import/download-template`)
    }
}